import { render, staticRenderFns } from "./History.vue?vue&type=template&id=13ebbe2f&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"
import style0 from "./History.vue?vue&type=style&index=0&id=13ebbe2f&prod&lang=css"
import style1 from "./History.vue?vue&type=style&index=1&id=13ebbe2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ebbe2f",
  null
  
)

export default component.exports